// extracted by mini-css-extract-plugin
export default {"header":"verify_header__Jt3DR","viewWalletBtn":"verify_viewWalletBtn__9F3dw","title":"verify_title__kZakc","body":"verify_body__xr730","exploreBtn":"verify_exploreBtn__QC5dk"};